import React, { useRef, useState } from 'react';
import '../Styles/Services.css'

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
// import required modules
import { EffectCoverflow, Pagination } from "swiper";
import CarouselServices from './CarouselServices';

const Services = () => {
    return (
        <>

            <div data-aos="zoom-out-right">
                <section className="services">
                    <div className="container">
                        <div className="info-service">
                            <h1 className="primary-text">
                                <div data-aos="zoom-out-left">
                                    <span className="blast">M</span>
                                    <span className="blast">y</span>
                                    ⠀
                                    <span className="blast">S</span>
                                    <span className="blast">e</span>
                                    <span className="blast">r</span>
                                    <span className="blast">v</span>
                                    <span className="blast">i</span>
                                    <span className="blast">c</span>
                                    <span className="blast">e</span>
                                    <span className="blast">s</span>
                                </div>
                            </h1>
                            <p className="about-text">
                                <div data-aos="flip-right">
                                    I can create Web sites, Telegram bots, Web Apps, Lending Pages, Online Stores. I create project very fast and quality and further I buy domain and web server for project.
                                    And you can get admin dashboard. My admin dashboard is very comfortable and very smart . for example you can delete, update or add product and more functions. You can add admins in dashboard, and all datas save in database    </div>
                            </p>
                        </div>
                        <div className="menu-service">
                            <div className="first">
                                <div className="hexagon-item">
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <i className="fa fa-universal-access"></i>
                                            </span>
                                            <span className="title">Web Site</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className="hexagon-item">
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <ion-icon name="logo-apple-ar"></ion-icon>
                                            </span>
                                            <span className="title">web Application</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>


                                <div className="hexagon-item">
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <i className="fa-brands fa-figma"></i>
                                            </span>
                                            <span className="title">Web design</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>


                                <div className="hexagon-item" >
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <i className="fa-solid fa-robot"></i>
                                            </span>
                                            <span className="title">Telegram bot</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="second">


                                <div className="hexagon-item">
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <ion-icon name="bar-chart-outline"></ion-icon>
                                            </span>
                                            <span className="title">Admin Dashboards</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className="hexagon-item">
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-item">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div className="hex-content">
                                        <span className="hex-content-inner">
                                            <span className="icon">
                                                <i class="fa-solid fa-database"></i>
                                            </span>
                                            <span className="title">DataBase</span>
                                        </span>
                                        <svg viewBox="0 0 173.20508075688772 200" height="200" width="174" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M86.60254037844386 0L173.20508075688772 50L173.20508075688772 150L86.60254037844386 200L0 150L0 50Z"
                                                fill="#1e2530"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="media-service">
                        <div className="service-box">
                            <div className="service-wraper">
                                <div className="title">
                                    <ion-icon name="cube-outline"></ion-icon>
                                    <h1>Web Sites</h1>
                                </div>
                                <p>I create online stores, lending pages, multi pager, portals, social media and i can clone web sites
                                    I can create web sites in React  Next or HTML5. My Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa ad ex similique consectetur impedit doloribus ratione deleniti sit iste neque?F
                                </p>
                                <span className='connect'>Order website <i className="fa-solid fa-right-long"></i></span>
                            </div>
                        </div>
                        <div className="service-box">
                            <div className="service-wraper">
                                <div className="title">
                                    <ion-icon name="apps-outline"></ion-icon>
                                    <h1>Admin Dashboard</h1>
                                </div>
                                <p> i create for you very comofratble and multi functional admin dashboard in this dashboard you can create product and update or delete. If data very big you can save exel, pdf , word doucment. In this dashboart you can post images , books , audio music or pdf files.  You can in 1 minute upload over 20 000 files because very fast server in our dashboard     </p>
                                <span className='connect'>Obzor admin <i className="fa-solid fa-right-long"></i></span>
                            </div>
                        </div>
                        <div className="service-box">
                            <div className="service-wraper">
                                <div className="title">
                                    <ion-icon name="at-circle-outline"></ion-icon>
                                    <h1>Telegram Bots</h1>
                                </div>
                                <p>I can create telegram bots for online store or delivery club or i can connect telegram  bot with web site admin dashboard or i can create telegram bot for admin dashboard other bot Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, corrupti. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum, porro. </p>
                                <span className='connect'>order telegram bot <i className="fa-solid fa-right-long"></i></span>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default Services;